import { useRequest } from 'ahooks'

import { toast } from '$app/utilities'

import { MobileOTPVerifyRequest } from '$api/types'
import { AnonymousAuthAPI } from '$api/anonymous-auth'

import { addToken } from '$store/session'

import { useSuccessLogin } from './useSuccessLogin'

const { mobileOTPVerify, errorMessageResolver, successResolver } =
  new AnonymousAuthAPI(null)

export const useMobileOTPVerify = () => {
  const onLoginSuccess = useSuccessLogin()

  const { loading, runAsync, error } = useRequest(mobileOTPVerify, {
    manual: true
  })

  const errorMessage = (() => {
    if (!error) return

    return errorMessageResolver(error, 'Invalid credential')
  })()

  const verify = async (data: MobileOTPVerifyRequest) => {
    const {
      data: { auth_token }
    } = await toast
      .promise(runAsync(data), {
        loading: 'Verifying..',
        success: 'Verified successfully'
      })
      .unwrap()
      .then(successResolver)

    const id = addToken(auth_token)

    onLoginSuccess(id)
  }

  return { verify, loading, errorMessage }
}

export default useMobileOTPVerify
